<template>
  <AdminUsers></AdminUsers>
</template>
  

<style src="./adminusers.css" scoped></style>
<script src="./adminusers.view.js"></script>

 